import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9930c522"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-bq",
  role: "dialog",
  "aria-label": "Hunt suggestions"
}
const _hoisted_2 = { class: "nge-bq-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-bq-kicker" }, "Suggestions", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-bq-title" }
const _hoisted_5 = {
  key: 0,
  class: "nge-bq-state"
}
const _hoisted_6 = {
  key: 0,
  class: "nge-bq-muted"
}
const _hoisted_7 = { class: "nge-bq-nav" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "nge-bq-count" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "nge-bq-what" }
const _hoisted_12 = { class: "nge-bq-when" }
const _hoisted_13 = {
  key: 0,
  class: "nge-bq-note"
}
const _hoisted_14 = {
  key: 1,
  class: "nge-bq-muted"
}
const _hoisted_15 = {
  key: 2,
  class: "nge-bq-flag"
}
const _hoisted_16 = {
  key: 4,
  class: "nge-bq-muted"
}
const _hoisted_17 = {
  key: 5,
  class: "nge-bq-veil"
}
const _hoisted_18 = { class: "nge-bq-actions" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 6,
  class: "nge-bq-preview"
}
const _hoisted_25 = { class: "nge-bq-noterow" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 7,
  class: "nge-bq-done",
  role: "status"
}
const _hoisted_28 = {
  key: 8,
  class: "nge-bq-win",
  role: "status"
}
const _hoisted_29 = {
  class: "nge-bq-burst",
  "aria-hidden": "true"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "nge-bq-wintitle" }, "Every suggestion checked!", -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-bq-wintext" }
const _hoisted_34 = { class: "nge-bq-foot" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<span class=\"nge-bq-legend\" data-v-9930c522><i class=\"nge-bq-dot nge-bq-dot--merge\" data-v-9930c522></i>merge points <i class=\"nge-bq-dot nge-bq-dot--red\" data-v-9930c522></i>red <i class=\"nge-bq-dot nge-bq-dot--blue\" data-v-9930c522></i>blue <i class=\"nge-bq-dot nge-bq-dot--piece\" data-v-9930c522></i>piece to join</span>", 1)
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 2,
  class: "nge-bq-muted"
}
const _hoisted_38 = {
  key: 3,
  class: "nge-bq-error",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.queue || $setup.error || $setup.busy === 'load')
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, "Hunt cell " + _toDisplayString($setup.queue ? `…${$setup.queue.cell.root.slice(-6)}` : ''), 1 /* TEXT */),
          ($setup.queue && !$setup.planting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.queue.cell.status === 'suggesting' ? 'Still taking suggestions' : $setup.queue.cell.status), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "nge-bq-x",
            "aria-label": "Close",
            onClick: $setup.close
          }, "×")
        ]),
        ($setup.busy === 'load')
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Loading…"))
          : ($setup.queue && $setup.sug)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "nge-bq-arrow",
                    disabled: $setup.idx === 0 || !!$setup.busy,
                    "aria-label": "The suggestion before",
                    onClick: _cache[0] || (_cache[0] = $event => ($setup.step($setup.idx - 1)))
                  }, "‹", 8 /* PROPS */, _hoisted_8),
                  _createElementVNode("span", _hoisted_9, _toDisplayString($setup.idx + 1) + " of " + _toDisplayString($setup.queue.suggestions.length) + ", oldest first", 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "nge-bq-arrow",
                    disabled: $setup.idx >= $setup.queue.suggestions.length - 1 || !!$setup.busy,
                    "aria-label": "The suggestion after",
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.step($setup.idx + 1)))
                  }, "›", 8 /* PROPS */, _hoisted_10),
                  _createElementVNode("span", {
                    class: _normalizeClass(["nge-bq-open", { 'nge-bq-open--none': !$setup.openCount }])
                  }, _toDisplayString($setup.openCount ? `${$setup.openCount} open` : 'All done'), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["nge-bq-chip", `nge-bq-chip--${$setup.sug.kind}`])
                  }, _toDisplayString($setup.sug.kind === 'merge' ? 'Merge' : 'Cut'), 3 /* TEXT, CLASS */),
                  _createTextVNode(" from "),
                  _createElementVNode("b", null, _toDisplayString($setup.sug.name), 1 /* TEXT */),
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.whenOf($setup.sug.t)) + " · " + _toDisplayString($setup.pointsLine), 1 /* TEXT */)
                ]),
                ($setup.sug.note)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, "\"" + _toDisplayString($setup.sug.note) + "\"", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.sug.kind === 'merge' && $setup.piece != null && !$setup.bigPiece && $setup.sug.status === 'open')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, "The piece to join, in violet, has " + _toDisplayString($setup.piece) + " level 2 " + _toDisplayString($setup.piece === 1 ? 'chunk' : 'chunks') + ".", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.bigPiece)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "The piece to join is big (" + _toDisplayString($setup.piece) + " chunks): a merge joins whole objects, so all of it comes along. You can still plant it, or cut a smaller piece off it first.", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.statusWords)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 3,
                      class: _normalizeClass(["nge-bq-status", { 'nge-bq-status--ok': $setup.sug.status === 'planted' }])
                    }, _toDisplayString($setup.statusWords), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true),
                (!$setup.planting && $setup.sug.status === 'open')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Close the suggestions and start planting (in the Hunt builder list) to plant."))
                  : ($setup.planting)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Veiled: players can't see this cell in Pyr until the Hunt starts."))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "nge-bq-btn",
                    disabled: !!$setup.busy,
                    onClick: $setup.goThere
                  }, _toDisplayString($setup.busy === 'go' ? 'Going…' : 'Go there again'), 9 /* TEXT, PROPS */, _hoisted_19),
                  ($setup.sug.status === 'open' && $setup.sug.kind === 'cut')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-bq-btn",
                        disabled: !!$setup.busy,
                        title: "Asks the graph what the cut would take off, before anything changes",
                        onClick: $setup.doPreview
                      }, _toDisplayString($setup.busy === 'preview' ? 'Asking…' : 'Preview the cut'), 9 /* TEXT, PROPS */, _hoisted_20))
                    : _createCommentVNode("v-if", true),
                  ($setup.sug.status === 'open')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "nge-bq-btn nge-bq-btn--plant",
                        disabled: !!$setup.busy || !$setup.planting,
                        onClick: $setup.plant
                      }, _toDisplayString($setup.busy === 'plant' ? 'Planting…' : `Plant it (${$setup.sug.kind})`), 9 /* TEXT, PROPS */, _hoisted_21))
                    : _createCommentVNode("v-if", true),
                  ($setup.sug.status === 'open')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "nge-bq-btn",
                        disabled: !!$setup.busy,
                        onClick: $setup.skip
                      }, _toDisplayString($setup.busy === 'skip' ? 'Skipping…' : 'Skip'), 9 /* TEXT, PROPS */, _hoisted_22))
                    : _createCommentVNode("v-if", true),
                  ($setup.sug.status === 'planted' && ($setup.planting || $setup.queue.cell.status === 'building'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "nge-bq-btn",
                        disabled: !!$setup.busy,
                        onClick: $setup.undo
                      }, _toDisplayString($setup.busy === 'undo' ? 'Undoing…' : 'Undo'), 9 /* TEXT, PROPS */, _hoisted_23))
                    : _createCommentVNode("v-if", true)
                ]),
                ($setup.preview)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString($setup.preview), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.note) = $event)),
                    class: "nge-bq-noteinput",
                    maxlength: "300",
                    placeholder: "A note (optional), only admins see it",
                    "aria-label": "A note on this suggestion"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.note]
                  ]),
                  ($setup.note.trim() && $setup.note.trim() !== $setup.sug.admin_note)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-bq-btn nge-bq-btn--small",
                        disabled: !!$setup.busy,
                        onClick: $setup.saveNote
                      }, _toDisplayString($setup.busy === 'note' ? 'Saving…' : 'Save note'), 9 /* TEXT, PROPS */, _hoisted_26))
                    : _createCommentVNode("v-if", true)
                ]),
                ($setup.done && !$setup.celebrate)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString($setup.done), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.celebrate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.burst, (g, i) => {
                          return (_openBlock(), _createElementBlock("svg", {
                            key: i,
                            class: "nge-bq-gem",
                            style: _normalizeStyle(g),
                            viewBox: "0 0 24 24",
                            width: "14",
                            height: "14"
                          }, _hoisted_31, 4 /* STYLE */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _hoisted_32,
                      _createElementVNode("span", _hoisted_33, _toDisplayString($setup.tally.all) + " " + _toDisplayString($setup.tally.all === 1 ? 'suggestion' : 'suggestions') + ": " + _toDisplayString($setup.tally.planted) + " planted, " + _toDisplayString($setup.tally.skipped) + " skipped. Next: Finish planting in the Hunt builder list, then Make the Hunt.", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("button", {
                    class: "nge-bq-btn nge-bq-btn--next",
                    disabled: $setup.nextOpen < 0 || !!$setup.busy,
                    onClick: _cache[3] || (_cache[3] = $event => ($setup.step($setup.nextOpen)))
                  }, "Next open ›", 8 /* PROPS */, _hoisted_36)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : ($setup.queue)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, "No suggestions on this cell yet."))
              : _createCommentVNode("v-if", true),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString($setup.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}